<h1>Subscribe to Albion Free Market</h1>
<!-- MARK: Verification Overlay -->
@if (showTurnstileOverlay()) {
  <div class="verification-overlay">
    <div class="verification-modal">
      <h2>Please Verify to Continue</h2>
      <div class="verification-wrapper">
        <ngx-turnstile [siteKey]="turnstileSiteKey" [theme]="(userSettingsService.userTheme$ | async) === 'albion-dark-theme' ? 'dark' : 'light'" (resolved)="onTurnstileResponse($event)" (errored)="onTurnstileError($event)"></ngx-turnstile>
      </div>
      <p class="verification-warning">This helps us prevent abuse and keep the service running smoothly</p>
    </div>
  </div>
}

<div class="page-container">
  <!-- MARK: Top Bar Section -->
  <div class="top-bar">
    <div class="top-bar-content">
      <!-- Login -->
      @if (!(authService.user$ | async)) {
        <div class="login-wrapper">
          <button mat-flat-button color="primary" (click)="authService.googleSignIn()">
            <div class="login-button-content">
              <img src="assets/img/google.svg" alt="Google Icon" />
              <span>Login with Google to Subscribe</span>
            </div>
          </button>
        </div>
      }
      <!-- Payment Info -->
      <div class="payment-info">
        <div class="secure-payment-box">
          <mat-icon svgIcon="lock"></mat-icon>
          <span>Guaranteed safe & secure checkout</span>
        </div>
        <a href="https://stripe.com" target="_blank" class="stripe-powered"> Powered by Stripe </a>
      </div>
    </div>
  </div>

  <!-- MARK: Notice -->
  <app-section sectionTitle="NOTICE">
    <div class="disclaimer-container">
      <p>Please read our <a routerLink="/tos" style="cursor: pointer">Terms of Service</a> before subscribing.</p>
      <p>By subscribing, you state that you understood and agree with all the terms of service.</p>
      <p>If you need help with billing or subscriptions, go to the <a routerLink="/feedback">Feedback / Contact Page</a>.</p>
    </div>
  </app-section>

  <!-- MARK: Value Deals -->
  <app-section sectionTitle="VALUE DEALS">
    <div class="subscription-cards-container">
      @for (prod of afmbe.activeProducts(); track $index) {
        @if (checkDiscount(prod.product)) {
          <mat-card
            class="card-hover"
            [ngClass]="{ 'banner-container': checkDiscount(prod.product) }"
            style="width: 320px; margin: 15px; display: flex; flex-direction: column; border-width: 2px; border-radius: 8px"
            [ngStyle]="{
              'box-shadow': prod.product.name.includes('Masterpiece') ? '0px 0px 10px 2px #f7db3b' : prod.product.name.includes('Outstanding') ? '0px 0px 10px 2px #23cffa' : '',
              'border-color': prod.product.name.includes('Masterpiece') ? '#f7db3b' : prod.product.name.includes('Outstanding') ? '#23cffa' : '',
            }"
            appearance="raised"
          >
            @if (checkDiscount(prod.product)) {
              <div class="banner right">{{ getDiscountText(prod.product) }}</div>
            }
            @if (activeSubscriptionsProductIds().includes(prod.product.id)) {
              <span class="badge mat-elevation-z4" [innerText]="'Your plan'"></span>
            }
            <mat-card-header style="display: flex; margin-bottom: 15px">
              <div style="display: flex; flex: auto; align-content: center">
                <div style="display: flex; margin-right: 15px">
                  <img style="margin: 0px 0px; align-self: center; border-radius: 0px; width: 60px" [src]="prod.product.images[0]" class="card-header-image" [alt]="prod.product.name" />
                </div>
                <div style="display: flex; flex-direction: column; flex: auto">
                  <mat-card-title>{{ prod.product.name }}</mat-card-title>
                  <mat-card-subtitle style="font-size: small">Stripe Subscription</mat-card-subtitle>
                </div>
              </div>
            </mat-card-header>
            <mat-card-content style="flex: auto">
              @for (line of prod.product.marketing_features; track $index) {
                <div style="display: flex; padding: 6px 0px; align-items: center; font-size: 12px; white-space: normal">
                  <mat-icon color="accent" style="margin: 0px 2px">check</mat-icon>
                  <span>{{ line.name }}</span>
                </div>
              }
            </mat-card-content>
            <mat-card-actions>
              <div
                style="display: flex; flex-direction: column; width: 100%"
                matTooltipPosition="above"
                [matTooltip]="isLoading() ? 'Loading...' : afmbe.afmStripeUserData().activeSubscriptions.length > 0 ? 'You already have an active subscription' : !(authService.user$ | async) ? 'Please login to subscribe' : ''"
              >
                @for (price of prod.prices; track $index) {
                  <button (click)="createCheckout(price, prod.product.name)" [disabled]="isLoading() || afmbe.afmStripeUserData().activeSubscriptions.length > 0 || !(authService.user$ | async)" class="subscribe-button" mat-stroked-button>
                    <mat-icon [svgIcon]="price.currency.toLowerCase()"></mat-icon>
                    SUBSCRIBE <span style="font-size: 12px">{{ price.currency.toUpperCase() }} {{ (price.unit_amount ?? 0) / 100 | number: '1.2-2' }}</span>
                    EVERY
                    {{ price.recurring?.interval_count }} {{ price.recurring?.interval?.toUpperCase() }}{{ (price.recurring?.interval_count ?? 0) > 1 ? 'S' : '' }}
                  </button>
                }
              </div>
            </mat-card-actions>
          </mat-card>
        }
      }
    </div>
  </app-section>

  <!-- MARK: Regular Subscriptions -->
  <app-section sectionTitle="REGULAR SUBSCRIPTIONS">
    <div class="subscription-cards-container">
      @for (prod of afmbe.activeProducts(); track $index) {
        @if (!checkDiscount(prod.product)) {
          <mat-card
            class="card-hover"
            [ngClass]="{ 'banner-container': checkDiscount(prod.product) }"
            style="width: 320px; margin: 15px; display: flex; flex-direction: column; border-width: 2px; border-radius: 8px"
            [ngStyle]="{
              'box-shadow': prod.product.name.includes('Masterpiece') ? '0px 0px 10px 2px #f7db3b' : prod.product.name.includes('Outstanding') ? '0px 0px 10px 2px #23cffa' : '',
              'border-color': prod.product.name.includes('Masterpiece') ? '#f7db3b' : prod.product.name.includes('Outstanding') ? '#23cffa' : '',
            }"
            appearance="raised"
          >
            @if (checkDiscount(prod.product)) {
              <div class="banner right">{{ getDiscountText(prod.product) }}</div>
            }
            @if (activeSubscriptionsProductIds().includes(prod.product.id)) {
              <span class="badge mat-elevation-z4" [innerText]="'Your plan'"></span>
            }
            <mat-card-header style="display: flex; margin-bottom: 15px">
              <div style="display: flex; flex: auto; align-content: center">
                <div style="display: flex; margin-right: 15px">
                  <img style="margin: 0px 0px; align-self: center; border-radius: 0px; width: 60px" [src]="prod.product.images[0]" class="card-header-image" [alt]="prod.product.name" />
                </div>
                <div style="display: flex; flex-direction: column; flex: auto">
                  <mat-card-title>{{ prod.product.name }}</mat-card-title>
                  <mat-card-subtitle style="font-size: small">Stripe Subscription</mat-card-subtitle>
                </div>
              </div>
            </mat-card-header>
            <mat-card-content style="flex: auto">
              @for (line of prod.product.marketing_features; track $index) {
                <div style="display: flex; padding: 6px 0px; align-items: center; font-size: 12px; white-space: normal">
                  <mat-icon color="accent" style="margin: 0px 2px">check</mat-icon>
                  <span>{{ line.name }}</span>
                </div>
              }
            </mat-card-content>
            <mat-card-actions>
              <div
                style="display: flex; flex-direction: column; width: 100%"
                matTooltipPosition="above"
                [matTooltip]="isLoading() ? 'Loading...' : afmbe.afmStripeUserData().activeSubscriptions.length > 0 ? 'You already have an active subscription' : !(authService.user$ | async) ? 'Please login to subscribe' : ''"
              >
                @for (price of prod.prices; track $index) {
                  <button (click)="createCheckout(price, prod.product.name)" [disabled]="isLoading() || afmbe.afmStripeUserData().activeSubscriptions.length > 0 || !(authService.user$ | async)" class="subscribe-button" mat-stroked-button>
                    <mat-icon [svgIcon]="price.currency.toLowerCase()"></mat-icon>
                    SUBSCRIBE <span style="font-size: 12px">{{ price.currency.toUpperCase() }} {{ (price.unit_amount ?? 0) / 100 | number: '1.2-2' }}</span>
                    EVERY
                    {{ price.recurring?.interval_count }} {{ price.recurring?.interval?.toUpperCase() }}{{ (price.recurring?.interval_count ?? 0) > 1 ? 'S' : '' }}
                  </button>
                }
              </div>
            </mat-card-actions>
          </mat-card>
        }
      }
    </div>
  </app-section>

  <!-- MARK: Disclaimer -->
  <app-section>
    <div class="disclaimer-container">
      <p>
        By confirming your <strong>RECURRING subscription</strong>, you allow Albion Free Market to charge you for future payments. You can always cancel your subscription in the
        <a routerLink="/manage-subscription">Manage Subscriptions</a> page. All subscriptions are non refundable.
      </p>
    </div>
  </app-section>

  <app-section sectionTitle="FREQUENTLY ASKED QUESTIONS">
    <div class="faq-list">
      <app-subsection subSectionTitle="What if I can't use Stripe?">
        <p>
          If you can't use Stripe, you can subscribe via <a href="https://patreon.com/AlbionFreeMarket" target="_blank">Patreon</a>, which also allows payment via PayPal. In this case, we will manually add subscription time for you. This is
          NOT the preferred method, and you should use Stripe if possible.
        </p>
        <p>
          Alternatively, you can subscribe via <a href="https://funpay.com/en/users/11955178/" target="_blank">Funpay</a>. As with Patreon, we will manually add subscription time for you. This is NOT the preferred method, and you should use
          Stripe if possible.
        </p>
        <p>
          You can also subscribe using cryptocurrencies. If interested, please contact us via
          <a href="https://discord.com/invite/BPmDE3zznH" target="_blank">Discord</a>. As with the other methods, this is a manual process and may take some time to complete.
        </p>
      </app-subsection>

      <app-subsection subSectionTitle="What happens if my automatic renewal fails?">
        <p>If your automatic renewal fails, your subscription will be cancelled. You can always create a new subscription.</p>
      </app-subsection>

      <app-subsection subSectionTitle="Is the payment safe?">
        <p>All payments are processed by <a href="https://stripe.com/" target="_blank">Stripe</a>. We do not store or access any payment information on our servers. Stripe is a secure and trusted payment processor used worldwide.</p>
        <p>
          We use
          <a href="https://docs.stripe.com/payments/checkout/how-checkout-works?payment-ui=stripe-hosted" target="_blank">Stripe's Hosted Checkout</a>
          to ensure maximum security for your payment information.
        </p>
      </app-subsection>

      <app-subsection subSectionTitle="How can I manage or cancel my subscriptions?">
        <p>You can manage or cancel your subscriptions in the <a routerLink="/manage-subscription">Manage Subscriptions</a> page.</p>
      </app-subsection>

      <app-subsection subSectionTitle="What do I get for subscribing?">
        <p>
          Subscribing to Albion Free Market is how you help us keep the website running and ad-free. As a thank you, subscribers receive enhanced access to flips, trade routes, the farming calculator and the crafting/refining calculator,
          with higher usage limits compared to non-subscribers.
        </p>
        <p>
          Albion Free Market does not sell Albion Online market data - that is freely available using the same public API's / software we use. Anyone can consume this data without cost thanks to the
          <a href="https://www.albion-online-data.com/" target="_blank">Albion Data Project</a>. What Albion Free Market provides is a good user interface and deep analytics for better in-game decision-making, using data that is publicly
          available or obtainable via free open-source software and APIs.
        </p>
        <p>
          Albion Free Market operates on custom-developed software that powers its market analysis and statistics, most of which are freely accessible for anyone to use. Developing and maintaining the software and user interface requires
          significant development hours, which come at a cost. Subscriptions help cover these expenses, including server costs and maintenance, ensuring the website remains ad-free.
        </p>
        <p>This is a solo project. No guaranteed level of support or service is provided. No level of in-game results (silver profit or similar) is guaranteed.</p>
      </app-subsection>

      <app-subsection subSectionTitle="Compliance with SBI Policies">
        <p>
          Albion Free Market is a tool designed to be used in accordance with the terms of service of Albion Online, as set by Sandbox Interactive (SBI). Our service utilizes passive monitoring of network traffic, a practice which SBI has
          publicly stated it does not consider an offense.
        </p>
        <ul>
          <li>
            SBI allows passive monitoring of network traffic for analysis:
            <blockquote>
              "As some of you have already pointed out, using WireShark or silimar tools to analyze network traffic is undetectable from our end and we therefore do not consider it an offense. The network packets do not contain any secret
              information, it is basically all stuff you can see on screen in the game in some form. If you wanna build a tool based on that - fine." (<a
                href="https://forum.albiononline.com/index.php/Thread/51604-Is-it-allowed-to-scan-your-internet-trafic-and-pick-up-logs/?postID=512670#post512670"
                target="_blank"
                >source</a
              >)
            </blockquote>
          </li>
        </ul>
        <p>
          While we strive to ensure compliance, SBI's policies may change, and the interpretation of their rules is at their sole discretion. We do not have control over SBI's decisions, and they do not officially endorse any third-party
          applications. You are solely responsible for understanding and complying with all applicable SBI policies, and for any consequences that may affect your game account. We strongly recommend that if you have any doubts, you contact
          SBI directly to make an informed decision.
        </p>
      </app-subsection>

      <app-subsection subSectionTitle="Where does the data come from?">
        <p>
          Albion Free Market mainly uses data from the
          <a href="https://www.albion-online-data.com/" target="_blank">Albion Data Project</a>, a community-driven project that collects and shares in-game data.
        </p>
        <p>
          Data can also be obtained via the
          <a href="https://github.com/JPCodeCraft/AlbionDataAvalonia" target="_blank">Albion Free Market Data Client</a>, which is open source and free to use, even if you're not an Albion Free Market user.
        </p>
        <p>All data consumed by Albion Free Market is publicly available or obtainable using free, open-source software.</p>
      </app-subsection>
    </div>
  </app-section>
</div>
